import { render, staticRenderFns } from "./DiscussionMgr.vue?vue&type=template&id=436073ac&scoped=true&"
import script from "./DiscussionMgr.vue?vue&type=script&lang=js&"
export * from "./DiscussionMgr.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionMgr.vue?vue&type=style&index=0&id=436073ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436073ac",
  null
  
)

export default component.exports